import { render, staticRenderFns } from "./UILoader.vue?vue&type=template&id=51e7a2f4&scoped=true&functional=true&"
import script from "./UILoader.vue?vue&type=script&lang=js&"
export * from "./UILoader.vue?vue&type=script&lang=js&"
import style0 from "./UILoader.vue?vue&type=style&index=0&id=51e7a2f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "51e7a2f4",
  null
  
)

export default component.exports